<template>
  <div id="app">
    <keep-alive :include="includes">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import { storage } from "./utils/util";
export default {
  mounted() {
    this.getArgument()
  },
  computed: {
    includes() {
      return this.$store.state.router;
    },
  },
  methods: {
    //获取参数
    getArgument() {
      var tokenUrl = location.href.split("#")[0]; // encodeURIComponent(location.href.split("#")[0]);
      this.$axios
        .request("/api/v1/app/wechat/fetch-sdk-params", {
          url: tokenUrl,
        })
        .then((res) => {
          // wx.checkJsApi({
          //   jsApiList: [
          //     "updateAppMessageShareData",
          //     "updateTimelineShareData",
          //     "onMenuShareAppMessage",
          //     "onMenuShareTimeline",
          //     "showMenuItems",
          //     "hideAllNonBaseMenuItem"
          //   ], // 需要检测的JS接口列表，所有JS接口列表见附录2,
          //   success: function (res) {
          //     console.log("check", res);
          //     // 以键值对的形式返回，可用的api值true，不可用为false
          //     // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
          //   },
          //   fail: function (res) {
          //     console.log('fail', res);
          //   }
          // });
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.data.appid, // 必填，公众号的唯一标识
            timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.data.noncestr, // 必填，生成签名的随机串
            signature: res.data.data.signature, // 必填，签名，见附录1
            jsApiList: [
              "updateAppMessageShareData",
              "updateTimelineShareData",
              "onMenuShareAppMessage",
              "onMenuShareTimeline",
              "showMenuItems",
              "hideAllNonBaseMenuItem"
            ],
            // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
        })
        .catch((err) => {
          // alert(JSON.stringify(err));
        });
    },
  },
};
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  overflow: auto;
}
#app::-webkit-scrollbar {
  width: 3px;
  height: 1px;
}
#app::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: #ededed;
}
#app::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
  border-radius: 3px;
  background: #ededed;
}

.beauty-scroll{
  scrollbar-color: #565656;
  scrollbar-width: thin;
  -ms-overflow-style:none;
  position: relative;
  overflow: auto;
}
.beauty-scroll::-webkit-scrollbar{
  width: 5px;
  height: 5px;
}
.beauty-scroll::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: #c1c1c1;
}
.beauty-scroll::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 1px rgba(0,0,0,0);
  border-radius: 3px;
  background: #ffffff00;
}
.maxHeight70{
  max-height: 70vh;
  overflow-y: auto;
}
</style>
